// extracted by mini-css-extract-plugin
module.exports = {"filters":"Filters_filters__Z8AHZ","categories":"Filters_categories__s_mAl","title":"Filters_title__sluBD","priceSlider":"Filters_priceSlider__Vsm_y","sliderWrapper":"Filters_sliderWrapper__KvdFy","hr":"Filters_hr__iXJUa"};
module.exports.__checksum = "15b0d81a094f"
